import { Components } from "@thisgorilla/primate-ds";
import { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { CreatePostModalContext } from "../..";
import { useContainerSize } from "../../../../../../../../hooks/useContainerSize";
import { useAppSelector } from "../../../../../../../../redux";
import { AudioPlayer } from "../../../../../../../Common";
import AudioProps from "./Audio";

const AudioPreview = ({
  selectedCollaborator,
}: AudioProps.AudioPreviewProps) => {
  const ref = useRef(null);
  const size = useContainerSize(ref);
  const [height, setHeight] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const { formik } = useContext(CreatePostModalContext);
  const { uploadedAudio, audioBackgroundImage } = useAppSelector(
    (state) => state.postAudio
  );

  useEffect(() => {
    if (ref?.current) {
      setHeight((ref?.current as Element)?.scrollHeight ?? 0);
    }
  }, [size, isOpen]);

  return (
    <AudioContainer $isShow={isOpen}>
      <PreviewHeading>
        <Components.Label kind="Fill" text="Preview" color="Primary" />
        <Components.IconButton
          kind="Secondary"
          iconType={isOpen ? "ChevronUp" : "ChevronDown"}
          disabled={false}
          size="Small"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        />
      </PreviewHeading>
      <PreviewBody ref={ref} height={isOpen ? height + 6 : 0}>
        <Container>
          <AudioPlayer
            {...{
              audio_description: formik.values.audio_description,
              audio_title: formik.values.audio_title,
              audioBackgroundImage,
              id: uploadedAudio?.id,
            }}
            isViewOnly={true}
            selectedCollaborator={selectedCollaborator.map((collaborator) => ({
              id: collaborator.id,
              name: collaborator.first_name + " " + collaborator.last_name,
              profile_picture: collaborator.profile_picture,
            }))}
          />
        </Container>
      </PreviewBody>
    </AudioContainer>
  );
};

export default AudioPreview;

export const AudioContainer = styled.div<{ $isShow: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme, $isShow }) =>
    $isShow
      ? theme.spacing["spacing-2"].value
      : theme.spacing["spacing-none"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-primary-subtle"].value};
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
`;

export const PreviewHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

export const PreviewBody = styled.div<{ height: number }>`
  max-height: ${({ height }) => height + "px"};
  overflow: hidden;
  transition: max-height 0.3s ease;
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}rem
    ${({ theme }) => theme.spacing["spacing-10"].value}rem;
`;

const Container = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;
